<template>
    <el-dialog v-model="dialogVisible" title="动火许可证" width="800px">
        <template #default>
            <div class="block" v-for="(item, index) in resData" :key="index">
                <!-- 文本域输入 -->
                <div class="text_area_bai" v-if="item.state == 2">
                    <div class="label">
                        {{ item.wordContext }}
                    </div>
                    <div class="text_box_area input_bai">
                        {{ item.value }}
                    </div>
                </div>
                <!-- 标题 -->
                <div class="title_bai" v-if="item.state == 4">
                    {{ item.title }}
                </div>
                <!-- 多选 -->
                <div class="checkBox_bai_warp" v-if="item.state == 1 && !item.refContextId">
                    <div class="checkBox_bai gui-flex gui-align-items-center" @click="selectOne(item)">
                        <text class="gui-icons no_select" v-show="!item.checked">&#xe692;</text>
                        <img src="@/assets/check.png" class="el-check is_select" v-show="item.checked" />
                        <div class="text">
                            {{ item.wordContext }}
                        </div>
                    </div>
                </div>
                <!-- 多选带输入 -->
                <div class="checkBox_bai_warp" v-if="item.state == 5 && !item.refContextId">
                    <div class="checkBox_bai gui-flex gui-align-items-center" @click="selectOne(item)">
                        <text class="gui-icons no_select" v-show="!item.checked">&#xe692;</text>
                        <img src="@/assets/check.png" class="el-check is_select" v-show="item.checked" />
                        <div class="text">
                            {{ item.wordContext }}
                        </div>
                    </div>
                    <div class="input_bai gui-flex gui-align-items-center">
                        {{ item.value }}
                    </div>
                </div>
                <!-- 多选多级 -->
                <div class="checkBox_bai_warp" v-if="item.state == 3 && item.children && item.children.length > 0">
                    <div class="checkBox_bai gui-flex gui-align-items-center" @click="selectOne(item)">
                        <text class="gui-icons no_select" v-show="!item.checked">&#xe692;</text>
                        <!-- <i class="el-icon-check is_select" v-show="item.checked"></i> -->
                        <img src="@/assets/check.png" class="el-check is_select" v-show="item.checked" />
                        <div class="text">
                            {{ item.wordContext }}
                        </div>
                    </div>
                    <div class="checkBox_bai checkbox_bai_child gui-flex gui-align-items-center"
                        @click="selectTwo(item, cItem)" v-for="(cItem, cIndex) in item.children">
                        <text class="gui-icons no_select" v-show="!cItem.checked">&#xe692;</text>
                        <!-- <i class="el-icon-check is_select" v-show="cItem.checked"></i> -->
                        <img src="@/assets/check.png" class="el-check is_select" v-show="cItem.checked" />
                        <div class="text">
                            {{ cItem.wordContext }}
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogVisible = false">关闭</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script>
export default {
    name: "PermitContainer",
    data() {
        return {
            dialogVisible: false,
            resData: [],
            sginList: {},
        };
    },
    methods: {
        open(data) {
            this.dialogVisible = true;
            if (data) {
                const res = JSON.parse(data)
                this.resData = res;
                console.log(this.resData);

            }
        },
        checkIsSelect(key) {
            if (this.resData.length <= 0) return;
            let checkList = this.resData.filter(e => e.id == key);
            if (checkList.length > 0) {// 有值
                return {
                    ...checkList[0],
                    checked: true
                }
            } else {
                return {
                    checked: false,
                    value: '--'
                }
            }
        },
        checkTimeSgin(index) {
            return false
        }
    },
};
</script>

<style scoped>
.text_box_area {
    text-align: left;
}
.gui-flex {
    display: flex;
}
.gui-align-items-center {
    align-items: center;
}
/* 保留原有样式 */
.licence_bai_ls {
    padding: 0 50px;
    box-sizing: border-box;
    background-color: #ffffff;
    font-size: 28px;
}

.checkBox_bai {
    padding: 6px 10px;
}

.checkBox_bai .no_select {
    font-size: 16px;
    color: #999999;
}

.checkBox_bai .is_select {
    font-size: 16px;
    color: #0024d2;
}

.checkBox_bai .text {
    margin-left: 10px;
}

.checkbox_bai_child {
    padding-left: 60px;
}

.text_area_bai .label {
    padding: 10px 0;
    font-size: 14px;
    text-align: left;
    font-weight: bold;
}

.text_area_bai .text_box {
    width: 100%;
    height: 50px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid rgba(204, 204, 204, 0.7);
    font-size: 14px;
    padding: 10px 5px;
    box-sizing: border-box;
    margin-bottom: 10px;
}

.title_bai {
    padding: 15px 0;
    margin-top: 10px;
    font-size: 14px;
    border-top: 1px solid #F8F8F8;
    text-align: left;
    font-weight: bold;
}

.input_bai {
    width: 100%;
    height: 60px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid rgba(204, 204, 204, 0.7);
    font-size: 14px;
    padding-left: 5px;
}

.btn_warp {
    padding: 60px 0;
}

.time_select {
    font-size: 18px;
    width: 689px;
    height: 58px;
    background: #F9F9F9;
    padding: 0 16px;
}

.red_color {
    color: #F3280C;
}

.el-check {
    width: 10px;
    height: 10px;
}
</style>